import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "After a week I must begrudgingly admit VSCode is a better editor than Emacs",
  "description": "",
  "published": "2017-11-10T00:00:00.000Z",
  "redirect_from": ["/blog/vscode-better-editor-emacs/swizec/7921"],
  "categories": "Livecoding, Opinions, Personal, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`10 years of love for Emacs undone by a week in VSCode.`}</p>
    <p>{`🤔`}</p>
    <lite-youtube {...{
      "videoid": "8kCd4w4kc68",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Last week, I wrote about `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/wont-be-switching-vscode/swizec/7898"
      }}>{`Why I won't be switching to VSCode any time soon`}</a>{`. Then `}<a parentName="p" {...{
        "href": "https://meta.wikimedia.org/wiki/Cunningham's_Law"
      }}>{`Cunningham's law`}</a>{` kicked in, I learned about some killer features, got tips on some config, and gave VSCode another chance.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`plus then you can slowly learn to become hopelessly dependent on this feature: `}<a parentName="p" {...{
          "href": "https://t.co/U0kUwijD6j"
        }}>{`pic.twitter.com/U0kUwijD6j`}</a></p>{`— Jason Miller 🦊⚛ (@_developit) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/_developit/status/926509015672160256"
      }}>{`November 3, 2017`}</a></blockquote>
    <p>{`That was the one. The feature that made me try VSCode for real. You can hover any function or variable, press command, and see its definition in a little popup. Or jump straight to the code.`}</p>
    <p>{`😍`}</p>
    <p>{`I think I have the perfect config going, and I'd share it with you, but I don't know how. Mainly I focused on getting a clean interface where code dominates.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/11/screenshot-1.png",
        "alt": null
      }}></img></p>
    <p>{`Blank slate with a bunch of code. The status bar is subtle, no activity bar, no cruft to the left or right of the code. No ugly vertical lines showing indentation.`}</p>
    <p>{`Change indicators still show up as subtle green or blue lines.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/11/screenshot-2.png",
        "alt": null
      }}></img></p>
    <p>{`It's great.`}</p>
    <p>{`Here's some stuff that still annoys me 👇`}</p>
    <ul>
      <li parentName="ul">{`tabs are huge, and there doesn't seem to be a config for that`}</li>
      <li parentName="ul">{`pressing Tab inserts a tab`}</li>
      <li parentName="ul">{`changing Tab to "line indent" works okay-ish, but not quite. I'd like to indent to automatic correct indentation instead of having to press it multiple times. When cursor is in indent space, tab should jump to beginning of line, when cursor is in code space, tab should indent or do nothing.`}</li>
      <li parentName="ul">{`I installed emacs keybindings to preserve muscle memory, and now jump-to-line shortcut doesn't work`}</li>
      <li parentName="ul">{`the `}<inlineCode parentName="li">{`cmd+P`}</inlineCode>{` magic search can be annoyingly dumb sometimes, and the UI struggles with long file paths. Shows beginning of path instead of the important stuff`}</li>
      <li parentName="ul">{`the `}<inlineCode parentName="li">{`cmd+O`}</inlineCode>{` shortcut isn't context aware. Opens UI at last visited folder instead of at current file`}</li>
      <li parentName="ul">{`no good shortcut for "jump back to previous file" that I can find`}</li>
    </ul>
    <p>{`Any ideas? `}<a parentName="p" {...{
        "href": "http://twitter.com/home?status=.@swizec%20you%20should%20try%20this%20for%20@code%20%F0%9F%91%89"
      }}>{`@ me`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      